import { STORAGE_PREFIX as prefix } from './redux';

export const isInfluencerView = (state) =>
  state[prefix].loggedInView === 'influencer';
